<div class="external-url">
      <span *ngIf="!isUrlLoaded" 
            class="external-url__loader sc-icon icon-loading sc-icon-2x spinner"></span>
      <iframe class="external-url__content"
              [src]="url | safe"
              (load)="onLoaded($event)"
              [ngClass]="{ 'hidden': !isUrlLoaded, 'showing':isUrlLoaded }"
              frameBorder="0">
      </iframe>
</div>